import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=1a397e69&scoped=true&"
import script from "./HelpPage.vue?vue&type=script&lang=js&"
export * from "./HelpPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=1a397e69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a397e69",
  null
  
)

export default component.exports